<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-dynamic" :inline="true">
            <el-form-item label="批量价格" prop="BatchPrice" class="BatchPrice">
                <el-input :disabled="stateDisabled" v-model="ruleForm.BatchPrice" size="small" class="input1"></el-input>
                <el-button :disabled="stateDisabled" type="primary" size="small" @click="batchSetting('price')">批量设置价格</el-button>
            </el-form-item>
            <el-form-item label="批量库存" prop="BatchInventory">
                <el-input :disabled="stateDisabled" v-model="ruleForm.BatchInventory" size="small" class="input1"></el-input>
                <el-button :disabled="stateDisabled" type="primary" size="small" @click="batchSetting('stock')">批量设置库存</el-button>
            </el-form-item>
        </el-form>
         
        <div v-for="(item, index) of skuList" :key="index" class="gauge">
            <div class="left">{{ item.skuNameKv.kvName }}</div>

            <div class="valueKv">
                <div class="kvName" v-for="element of item.valueKvList">
                    <!-- <i class="el-icon-close close" @click="closekvName(element.kvName)"></i> -->
                    {{ element.kvName }} 
                </div>
            </div>
            
        </div>
        <el-table size="small" :data="tableData" max-height="450px" border style="width: 100%" v-if="tableData.length != 0">
            <el-table-column
                v-for="(item, index) of skuList"
                :key="index"
                align="center"
                :prop="'kvName' + index"
                :label="item.skuNameKv.kvName"
            >
            </el-table-column>
             
            <el-table-column align="center" label="价格">
                <template slot-scope="scope"
                    ><el-input
                        size="small"
                        style="width: 60%"
                        :disabled="stateDisabled"
                        v-model="scope.row.price"
                        placeholder="请输入价格"
                    ></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="库存">
                <template slot-scope="scope"
                    ><el-input
                        size="small"
                        style="width: 60%"
                        :disabled="stateDisabled"
                        v-model="scope.row.stock"
                        placeholder="请输入库存"
                    ></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="图片">
                <template slot-scope="scope">
                    <el-upload
                        class="avatar-uploader"
                        style="width: 80px; height: 80px; text-align: center"
                        :data="scope.row"
                        :disabled="stateDisabled"
                        action=""
                        :show-file-list="false"
                        :http-request="uploadSkuPicture"
                    >
                        <img v-if="scope.row.pic" :src="scope.row.pic" class="avatar" size="small" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button
                        v-if="!stateDisabled"
                        type="danger"
                        size="small"
                        @click="deleteSku(scope.row)"
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 新增：表格数据底部下方 input 行 -->
        <div v-if="!stateDisabled && skuList.length > 0">新增商品规格值</div>
        <div v-if="!stateDisabled && skuList.length > 0" style="margin: 10px 0;">            
            <div style="display: flex; justify-content: space-between; width: 100%;">
                <template v-for="(item, index) in skuList">
                    <div :key="'input-col-' + index" :style="{ width: 'calc(100% / ' + (skuList.length + 2) + ')' }" style="text-align: center">
                        <el-input
                            size="small"
                            style="width: 100%"
                            :disabled="stateDisabled"
                            v-model="newRow['kvName' + index]"
                            placeholder="请输入规格值"
                            @blur="$event => getSkuValue(index, newRow['kvName' + index],item.nameKvId)"
                        ></el-input>
                    </div>
                </template>

                <div :style="{ width: 'calc(100% / ' + (skuList.length + 2) + ')' }" style="text-align: center">
                    <el-input
                        size="small"
                        style="width: 100%"
                        :disabled="stateDisabled"
                        v-model="newRow.price"
                        placeholder="价格"
                    ></el-input>
                </div>
                <div :style="{ width: 'calc(100% / ' + (skuList.length + 2) + ')' }" style="text-align: center">
                    <el-input
                        size="small"
                        style="width: 100%"
                        :disabled="stateDisabled"
                        v-model="newRow.stock"
                        placeholder="库存"
                    ></el-input>
                </div>
                <div :style="{ width: 'calc(100% / ' + (skuList.length + 2) + ')' }" style="text-align:center">
                    <el-upload
                        class="avatar-uploader"
                        style="width: 100%; text-align: center"
                        :data="newRow"
                        action=""
                        :show-file-list="false"
                        :http-request="uploadSkuPicture"
                    >
                        <img v-if="newRow.pic" :src="newRow.pic" class="avatar" style="width: 40px; height: 40px" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
            </div>
            <el-button type="success" @click="addNewRow" >新增</el-button>
        </div>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import { get, post, deleteFun, upload ,postJson } from '@/utils/request.js';
export default {
    props:{
        showDialog:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            ruleForm: {
                BatchPrice: '',
                BatchInventory: '',
                Specifications: ''
            },
            Specifications: '',
            rules: {},
            skuList: [],
            skuValueList: [],
            brand: {},
            tableData: [],
            arrData: [],
            stateDisabled: false,
            // 新增数据绑定字段
            newRow: {
                price: '',
                stock: '',
                pic: ''
            },
            // 存储每个规格对应的 kvId
            kvIdList: [],
            // 防抖定时器
            debounceTimer: null,
            shopProductSkuDTOList: []
        };
    },
    watch: {
        showDialog(val , oldVal) {
            if (!val && oldVal) {
                 this.newRow = {
                        price: '',
                        stock: '',
                        pic: ''
                    };
            }
        }
    },
    created() {
        eventBus.$on('skuList', (data, value, state) => {
            console.log('skuList的data',data);
            console.log('skuList的data',value);
            this.skuList = data;
            this.skuValueList = value;
            if (state == 'check') {
                this.stateDisabled = true;
            } else {
                this.stateDisabled = false;
            }
            this.combination();
        });
    },
    beforeDestroy() {
        eventBus.$off('skuList');
    },
    methods: {
        // 删除规格
        deleteSku(row){
           console.log('row',row);
           this.$confirm('此操作将永久删除该规格, 是否继续?', '提示', { 
           }).then(()=>{
               get('/shop/productSku/value/deleteById',{ id: row.id,}).then((res) => {
                    if (res.success ) {
                        this.$message({
                            message: '删除规格成功',
                            type: 'success',
                            duration: 2000
                        });
                       this.$emit('closeDialogShow', true);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
           })
        },
        closekvName(element) {
            console.log(element);
            loop: for (let item of this.skuList) { 
                for (let i = 0; i < item.valueKv.length; i++) {
                    if (item.valueKv[i].kvName == element) {
                        item.valueKv.splice(i, 1);
                        this.combination();
                        break loop;
                    }
                }
            }
            for (let i = 0; i < this.skuList.length; i++) {
                if (this.skuList[i].valueKv == 0) {
                    console.log(this.skuList[i]);
                    eventBus.$emit('speckvName', this.skuList[i].kvName);
                    this.skuList.splice(i, 1);
                    if (this.skuList.length != 0) {
                        this.combination();
                    }
                    break;
                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
  
     combination() {
               let combine = function (skuList) {
                // console.log(skuList);
                let res = [];
                let recursion = function (chunkIndex, prev) {
                    let skuValueList = skuList[chunkIndex].valueKvList;
                    // console.log(skuValueList);

                    let isLast = chunkIndex === skuList.length - 1;
                    for (let val of skuValueList) {
                        let temporary = prev.concat(val);
                        if (isLast) {
                            // 如果已经处理到数组的最后一项了 则把拼接的结果放入返回值中
                            res.push(temporary);
                        } else {
                            recursion(chunkIndex + 1, temporary);
                        }
                    }
                };
                // 从属性数组下标为 0 开始处理  // 并且此时的 prev 是个空数组
                recursion(0, []);
                return res;
            };
            let arr = combine(this.skuList);
            console.log(arr);
            this.tableData = [];
            let j = 0;
            // 使用 Set 去重
            const existingSkus = new Set();
            for (let item of arr) {
                let i = 0;
                let obj = {
                    skuKvIds: ''
                };

                for (let element of item) {
                    let key1 = 'kvName' + i;
                    let key2 = 'price';
                    let key3 = 'stock';
                    let key4 = 'pic';
                    let key5 = 'id';
                    i++;
                    obj[key1] = element.kvName;
                    obj[key2] = '';
                    obj[key3] = '';
                    obj[key4] = '';
                    obj[key5] = j++;
                    obj.skuKvIds += element.kvId + ',';
                }
                if (obj.skuKvIds.length > 0) {
                    obj.skuKvIds = obj.skuKvIds.substr(0, obj.skuKvIds.length - 1);
                }
                obj.skuKvIds = this.ascending(obj.skuKvIds);

                this.tableData.push(obj);
              
            }
            this.format();
        },
        format() {
          
            for (let item of this.tableData) {
                for (let element of this.skuValueList) {
                    if (item.skuKvIds == this.ascending(element.skuKvIds)) {
                        item.id = element.id;
                        item.pic = element.pic;
                        item.price = element.price;
                        item.stock = element.stock;
                        item.productId = element.productId;
                        break;
                    }
                }
            }
        this.tableData = this.tableData.filter(item => item.pic || item.stock || item.price );
            
        },
        // 升序排列
        ascending(value) {
            var array = new Array();
            array = value.split(',');
            // for (var element in array) {
            //     array[element] = parseInt(array[element]);
            // }
            array = array.sort(function (a, b) {
                return a - b;
            });
            return array.toString();
        },
     
        // 上传图片
        uploadSkuPicture(params) {
            const file = params.file;
            let product = params.data;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success && res.code == 200) {
                    // 判断是否是 newRow 的上传
                    if (product == this.newRow) {
                        product.pic = res.url;
                    } else {
                        for (let item of this.tableData) {
                            if (item.id == product.id) {
                                item.pic = res.url;
                            }
                        }
                    }
                }
            });
        },
        // 批量设置
        batchSetting(value) {
            if (this.tableData.length != 0) {
                for (let item of this.tableData) {
                    if (value == 'price') {
                        if (this.ruleForm.BatchPrice == '') {
                            this.$message({
                                message: '价格不能为空',
                                type: 'error',
                                duration: 2000
                            });
                            return;
                        }
                        item.price = this.ruleForm.BatchPrice;
                    }
                    if (value == 'stock') {
                        if (this.ruleForm.BatchInventory == '') {
                            this.$message({
                                message: '库存不能为空',
                                type: 'error',
                                duration: 2000
                            });
                            return;
                        }
                        item.stock = this.ruleForm.BatchInventory;
                    }
                }
                if (value == 'price') {
                    this.ruleForm.BatchPrice = '';
                }
                if (value == 'stock') {
                    this.ruleForm.BatchInventory = '';
                }
            }
        },
      
       // 获取规格值对应的 kvId
    async getSkuValue(index, value, nameKvId) {
        if (!value) {
            this.$set(this.kvIdList, index, null);
            return;
        }

        // 清除之前的定时器
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        // 设置新的定时器，0.5秒后执行请求
        this.debounceTimer = setTimeout(async () => {
            try {
                const res = await get('/shop/attrkv/getByName', { kvName: value });

                if (res.success) {
                    const { kvId } = res.shopAttrKv;
                    this.$set(this.kvIdList, index, kvId);

                    // 遍历 skuList 查找匹配项
                    const newSkuList = [...this.skuList];
                    for (let i = 0; i < newSkuList.length; i++) {
                        if (newSkuList[i].nameKvId === nameKvId) {
                            let currentIds = newSkuList[i].valueKvIds || '';
                            let idArray = currentIds.split(',').filter(Boolean);

                            // 防止重复添加
                            if (!idArray.includes(kvId.toString())) {
                                idArray.push(kvId);
                            }

                            // 替换数组中对应项
                            newSkuList[i] = {
                                ...newSkuList[i],
                                valueKvIds: idArray.join(',')
                            };

                            // 找到后跳出循环
                            break;
                        }
                    }

                    // 一次性赋值，减少响应式触发次数
                    this.skuList = newSkuList;

                } else {
                    this.$set(this.kvIdList, index, null);
                    this.$message.warning(`第 ${index + 1} 个规格值无对应 kvId`);
                }
            } catch (error) {
                this.$set(this.kvIdList, index, null);
                this.$message.error(`获取第 ${index + 1} 个规格值失败`);
                console.error(error);
            }
        }, 500); // 500ms 防抖延迟
    },
        //规格kiid数据
        addSku(){ 
        // 将处理后的 skuList 赋值给 shopProductSkuDTOList
            this.shopProductSkuDTOList = this.skuList.map(item => ({
                ...item,
                valueKvIds: item.valueKvIds
            }));
             this.shopProductSkuDTOList.forEach(item => {
                delete item.skuNameKv;
                delete item.valueKvList;
            });
            this.$confirm('确定新增规格吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                 postJson('/shop/productSku/value/insert', {
                    productId: this.$store.state.productSpecificationId, // 商品id
                    price:this.newRow.price,
                    stock:this.newRow.stock,
                    pic: this.newRow.pic,
                    skuKvIds:this.newRow.skuKvIds,
                    shopProductSkuDTOList:this.shopProductSkuDTOList
                 }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: '新增规格成功',
                            type: 'success',
                            duration: 2000
                        });
                        this.resetInput();
                        this.$emit('closeDialogShow', true);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            });
        },
        // 新增行逻辑
        addNewRow() {
             
            if (!this.validateRow()) return;
            const newRow = { ...this.newRow };
            newRow.skuKvIds = '';

            for (let i = 0; i < this.skuList.length; i++) {
                let key = 'kvName' + i;
                newRow.skuKvIds += this.kvIdList[i] ? this.kvIdList[i] + ',' : '';
            }

            if (newRow.skuKvIds.endsWith(',')) {
                newRow.skuKvIds = newRow.skuKvIds.slice(0, -1);
            }

            newRow.skuKvIds = this.ascending(newRow.skuKvIds);

            // 防止重复添加相同规格组合
            const isDuplicate = this.tableData.some(
                item => item.skuKvIds === newRow.skuKvIds
            );

            if (isDuplicate) {
                this.$message.warning('该规格组合已存在');
                return;
            }
            this.newRow.skuKvIds = newRow.skuKvIds; 
            this.addSku()
        },
        // 数据校验
        validateRow() {
            for (let i = 0; i < this.skuList.length; i++) {
                const value = this.newRow['kvName' + i];
                if (!value || (typeof value == 'string' ? !value.trim() : !value.kvName)) {
                    this.$message.error(`第 ${i + 1} 个规格值不能为空`);
                    return;
                }
            }
            if (!this.newRow.price.trim()) {
                this.$message.error('请输入价格');
                return false;
            }
            if (!this.newRow.stock.trim()) {
                this.$message.error('请输入库存');
                return false;
            }
            if( !this.newRow.pic) {
                this.$message.error('请上传图片');
                return false;
            }
            return true;
        },
        // 重置输入框
        resetInput() {
            this.newRow = {
                price: '',
                stock: '',
                pic: ''
            };
            for (let i = 0; i < this.skuList.length; i++) {
                this.$set(this.newRow, 'kvName' + i, '');
                this.$set(this.kvIdList, i, null);
            }
        },
        // 刷新 SKU 表格（可选）
        // refreshTable() {
        //     this.format();
        // }
    }
};
</script>
<style lang="scss" scoped>
.input1 {
    margin-right: 15px;
}
.Specifications {
    padding-left: 100px;
    margin-bottom: 22px;
}
.input2 {
    width: 50%;
    margin: 10px 0;
}
::v-deep .el-input {
    width: 100px;
}
::v-deep .el-select {
    width: 100px;
}
::v-deep .el-form-item {
    margin-bottom: 10px;
}

.gauge {
    color: #606266;
    font-weight: normal;
    font-size: 14px;
    display: -webkit-box;
    .left {
        line-height: 32px;
        width: 58px;
        margin-right: 12px;
        text-align: right;
    }
}
.valueKv {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .kvName {
        padding: 0 10px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #ccc;
        margin: 0 10px 10px 0;
        position: relative;
    }
    .close {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        background-color: #409eff;
        color: #fff;
        border-radius: 100%;
    }
}
.el-table {
    margin-bottom: 20px;
}

::v-deep .el-upload {
    width: 80px !important;
    height: 80px !important;
    text-align: center;
}
.avatar-uploader {
    margin-left: 50%;
    transform: translate(-50%, 0);
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.avatar {
    width: 80px;
    height: 80px;
    display: block;
}
</style>
